import className from './vertical-spacer.module.scss';

interface VerticalSpacerProps {
    size: number;
}

export default function VerticalSpacer(props: VerticalSpacerProps) {
    return <div className={className.base} style={{ height: props.size }} />;
}
